const LISTEN_TAG = 'dn-store';

let $seg;



export default {
  namespaced: true,

  state: {
    uid : null,
    type: null,
  },

  getters: {
    uid: state => state.uid,
    type: state => state.type,
    typeName: state => state.type == 1 ? 'PC' : 'SP',
  },

  actions: {
    init({commit, dispatch}) {
      $seg = window.bcBanner.segments;
      commit('restore');
      dispatch('startWatch');
    },

    startWatch({commit}) {
      $seg.device.listen(e => {
        commit('restore');
      }, LISTEN_TAG);
    },
  },

  mutations: {
    restore: state => {
      const data = $seg.device.get();
      state.uid  = data.uid;
      state.type = data.type;
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/segments/modules/device.js